module.exports = __webpack_public_path__ + "img/commbook.504d2e06.svg";